import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '@shared/core';
import { GlobalStyle, JoyKitThemeProvider } from '@withjoy/joykit';
import { CreateEventStateProvider } from '@shared/createEvent/CreateEventState';
import { AllowedDesignParamsProvider } from '@shared/createEvent/AllowedDesignParamsProvider';

import { RouterCreateBabyRegistry } from '@apps/createBabyRegistry/route.paths';
import { CREATE_BABY_REGISTRY_APP_NAME } from '@apps/createBabyRegistry/constants';
import { TelemetryProvider } from '@apps/createBabyRegistry/CreateBabyRegistry.telemetry';
import { useSaveCurrentAcquisitionContext } from '@shared/createEvent/acquisitionContextTracking';
import { Seo } from '@shared/components/Seo';

const CreateBabyRegistryApp = () => {
  const { t } = useTranslation('createBabyRegistry');
  useSaveCurrentAcquisitionContext();

  return (
    <JoyKitThemeProvider>
      <Seo title={t('title')()} description={t('description')()} />
      <Helmet>
        <link rel="canonical" href="https://withjoy.com/createbabyregistry" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <TelemetryProvider>
        <AllowedDesignParamsProvider>
          <CreateEventStateProvider>
            <GlobalStyle />
            <RouterCreateBabyRegistry appUrl={CREATE_BABY_REGISTRY_APP_NAME} />
          </CreateEventStateProvider>
        </AllowedDesignParamsProvider>
      </TelemetryProvider>
    </JoyKitThemeProvider>
  );
};

export default CreateBabyRegistryApp;
